// extracted by mini-css-extract-plugin
export default {"reply":"reply-dialog_reply__XDD6Y"};